export const randBetween = (min: number, max: number, toInt?: boolean) => {
  const rnd = Math.random() * (max - min + 1) + min;
  return toInt ? Math.floor(rnd) : rnd;
};

export function isNumber(num: unknown): num is number {
  return typeof num === 'number' && !Number.isNaN(num);
}
